export const SHIPPING_TYPE_ENUMS = {
  PARCEL: "parcel",
  FREIGHT: "freight",
}
export const SHIPPING_TYPE_VALUES = Object.values(SHIPPING_TYPE_ENUMS);
export const SHIPPING_TYPE_LABELS = {
  [SHIPPING_TYPE_ENUMS.PARCEL]: "Paket Parcel",
  [SHIPPING_TYPE_ENUMS.FREIGHT]: "Kargo",
}

export const SHIPMENT_DURATION_UNIT_ENUMS = {
  HOUR: "hour",
  DAY: "day",
}
export const SHIPMENT_DURATION_UNIT_VALUES = Object.values(SHIPMENT_DURATION_UNIT_ENUMS);
export const SHIPMENT_DURATION_UNIT_LABELS = {
  [SHIPMENT_DURATION_UNIT_ENUMS.HOUR]: "Jam",
  [SHIPMENT_DURATION_UNIT_ENUMS.DAY]: "Hari",
}

export const COLLECTION_METHOD_ENUMS = {
  PICKUP: "pickup",
  DROP_OFF: "drop_off",
}
export const COLLECTION_METHOD_VALUES = Object.values(COLLECTION_METHOD_ENUMS);
export const COLLECTION_METHOD_LABELS = {
  [COLLECTION_METHOD_ENUMS.PICKUP]: "Dijemput kurir",
  [COLLECTION_METHOD_ENUMS.DROP_OFF]: "Drop off ke gerai kurir",
}

export const SERVICE_TYPES_ENUMS = {
  SAME_DAY: "same_day",
  STANDARD: "standard",
  OVERNIGHT: "overnight",
  INSTANT: "instant",
}
export const SERVICE_TYPES_VALUES = Object.values(SERVICE_TYPES_ENUMS);
export const SERVICE_TYPES_LABELS = {
  [SERVICE_TYPES_ENUMS.INSTANT]: "Instant",
  [SERVICE_TYPES_ENUMS.SAME_DAY]: "Same Day",
  [SERVICE_TYPES_ENUMS.OVERNIGHT]: "Next Day",
  [SERVICE_TYPES_ENUMS.STANDARD]: "Standard",
}